import { render, staticRenderFns } from "./badges.vue?vue&type=template&id=dfa2e96e&"
import script from "./badges.vue?vue&type=script&lang=ts&"
export * from "./badges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports